module.exports = __webpack_public_path__ + "img/logo.6aa5b6c5.svg";